var _style, _g, _path, _path2, _g2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlasmaBcaAsGlucoseLevels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill:#2A384F;}\n\t.st2{fill:none;stroke:#2A384F;stroke-width:6.2489;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.9,130.4c-2,0-3.6-1.6-3.6-3.6c0-1.9,1.6-3.5,3.5-3.5c2,0,3.6,1.6,3.6,3.6 C145.4,128.7,143.8,130.3,141.9,130.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,141.1c0,2-1.7,3.6-3.7,3.6c-1.9-0.1-3.5-1.6-3.5-3.6c0-2,1.7-3.6,3.7-3.6C79.5,137.6,81.1,139.2,81,141.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "55.1,97.5 63.4,105.3 91.2,105.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "77,105.9 70.7,126.1 62.9,126.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "84.8,61.7 84.8,68.9 105,75.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "114.3,54.4 106.5,62.8 106.5,90.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "149.8,84.2 141.7,84.2 135.4,105  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "120.6,105.3 149.5,105.3 157.3,113.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.9,
    cy: 105.9,
    r: 13.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "99,155.9 106.5,147.5 106.5,119.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "128.4,149.2 128.4,141.7 107.1,134.2  "
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.2,69.6c0,2-1.6,3.6-3.6,3.6c-1.9,0-3.5-1.6-3.5-3.5c0-2,1.6-3.6,3.6-3.6C136.7,66.1,138.2,67.6,138.2,69.6 z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 76.4,
    cy: 83.9,
    r: 3.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaBcaAsGlucoseLevels);
export default __webpack_public_path__ + "static/media/Plasma_BCAAs_GlucoseLevels.c9cf47f5268376d02e4bfb6505d3f2e5.svg";
export { ForwardRef as ReactComponent };